import ElementConstants from '../../../shared/constants/elements';

// NOTE: The order of keys in this object will determine the order in which
// blocks display in the sidebar

const InputBlocks = {
	TEXT: {
		type: ElementConstants.INPUTS.TEXT,
		label: 'Short Answer',
		icon: 'letters-boxed'
	},
	TEXTAREA: {
		type: ElementConstants.INPUTS.TEXTAREA,
		label: 'Long Answer',
		icon: 'paragraph-boxed'
	},
	NUMBER: {
		type: ElementConstants.INPUTS.NUMBER,
		label: 'Number',
		icon: 'numbers'
	},
	LINK: {
		type: ElementConstants.INPUTS.LINK,
		label: 'Link',
		icon: 'link'
	},
	EMAIL: {
		type: ElementConstants.INPUTS.EMAIL,
		label: 'Email',
		icon: 'envelope-o'
	},
	PHONE: {
		type: ElementConstants.INPUTS.PHONE,
		label: 'Phone',
		icon: 'phone'
	},
	DATE: {
		type: ElementConstants.INPUTS.DATE,
		label: 'Date',
		icon: 'calendar'
	},
	TIME: {
		type: ElementConstants.INPUTS.TIME,
		label: 'Time',
		icon: 'clock-4pm'
	},
	FILE_UPLOAD: {
		type: ElementConstants.INPUTS.FILE_UPLOAD,
		label: 'File upload',
		icon: 'paperclip'
	},
	USER_SIGNATURE: {
		type: ElementConstants.INPUTS.USER_SIGNATURE,
		label: 'Signature',
		icon: 'signature'
	}
}

export default InputBlocks;



// WEBPACK FOOTER //
// ./src/main/webapps/features/form-builder/react/editor/constants/blocks/inputs.js